import '@babel/polyfill' //(一定要在最上面，第一行)
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'


const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.use(router)
app.use(ElementPlus)
app.mount('#app')

import router from './router/index'

//导出路由
export default router